import { makeStyles } from '@mui/styles'
import MuiAlert, { AlertProps, AlertColor } from '@mui/lab/Alert'
import { Snackbar, Theme  } from '@mui/material'
import React, { useEffect } from 'react'
import { IToasterComponentProps } from './types/IToasterComponentProps'
import { useSelector, useDispatch } from 'react-redux';
import TOASTER_DATA from './constants';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
	props,
	ref,
  ) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  

const useStyles : any = makeStyles((theme: Theme) => ({
	root: {
		width: '100%',
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
}))

export const ToasterComponent: React.FunctionComponent<IToasterComponentProps> = (
	props: IToasterComponentProps
) => {
	const classes = useStyles()
	const [open, setOpen] = React.useState(false)
	const [message, setMessage] = React.useState()
	const [type, setType] = React.useState('error' as AlertColor)
    const data = useSelector((state:any)=>{
		return state[TOASTER_DATA]
	})
	useEffect(() => {
		if (data.type) {
			setMessage(data.message)
			setType(data.type as AlertColor)
			setOpen(true)
		} else if (data.length > 0) {
			setMessage(data)
			setOpen(true)
		}
	}, [data])

	const handleClose = (event?: any, reason?: string) => {
		if (reason === 'clickaway') {
			return
		}

		setOpen(false)
	}

	return (
		<div className={classes.root}>
			<Snackbar
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				open={open}
				autoHideDuration={7000}
				onClose={handleClose}
			>
				<Alert onClose={handleClose} severity={type}>
					{message}
				</Alert>
			</Snackbar>
			{/* <Alert severity="error">This is an error message!</Alert>
			<Alert severity="warning">This is a warning message!</Alert>
			<Alert severity="info">This is an information message!</Alert>
			<Alert severity="success">This is a success message!</Alert> */}
		</div>
	)
}
